import { render, staticRenderFns } from "./el-radio-button.vue?vue&type=template&id=5d5a394f"
import script from "./el-radio-button.vue?vue&type=script&lang=js"
export * from "./el-radio-button.vue?vue&type=script&lang=js"
import style0 from "./el-radio-button.vue?vue&type=style&index=0&id=5d5a394f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports